import React, { PropsWithChildren } from 'react';
import { Accordion, Row, Card } from 'react-bootstrap';
import { IFieldSetProps } from '../types/IFieldSetProps';

function AccordionFieldSet({
    children,
    description,
    fieldSetName,
    visible,
    iconSrc,
}: PropsWithChildren<IFieldSetProps>) {
    return (
        <div className="container-fluid" style={{ display: visible ? 'block' : 'none' }}>
            <Accordion defaultActiveKey="0" className="applicant-content">
                <div className="col-12 fieldset-title">
                    <Accordion.Toggle
                        as={Card.Header}
                        variant="link"
                        eventKey="0"
                        className="d-flex align-items-center justify-content-between"
                    >
                        <h5>
                            <span className="numberCircle" />
                            {iconSrc && <img src={iconSrc} alt="" />}
                            <span>{fieldSetName}</span>
                        </h5>
                        <span className="arrow-right-white" />
                    </Accordion.Toggle>
                </div>
                <div
                    className="col-12 my-4"
                    dangerouslySetInnerHTML={{ __html: description || '' }}
                />
                <Accordion.Collapse eventKey="0">
                    <Row>{children}</Row>
                </Accordion.Collapse>
            </Accordion>
        </div>
    );
}

export default AccordionFieldSet;
